import { omit } from "ramda";

export const ErrorRenderer = ({ errors }: { errors: any }) => {
  const msg = processErrors(errors);
  return <div>{msg}</div>;
};

const processErrors = (errors: any) => {
  console.log("errors", errors);
  try {
    // return safeStringify(errors).replace("{", "").replace("}", "")

    const ers = Object.keys(errors).flatMap((key: string) => {
      const item = errors[key];
      if (typeof item == "function") return [];

      return item;
    });

    if (ers?.length === 0) return <></>;

    return (
      <div
        style={{
          backgroundColor: "rgba(255, 0,0, 0.5)",
          width: "50%",
          padding: 16,
          marginBottom: 16,
          borderRadius: 16,
          margin: 'auto',
          marginTop: 16,
        }}
      >
        <h3>Validation Errors</h3>
        {ers.map((item) => {
          if (!item.message) {
            return Object.keys(item).map((k) => {
              // console.log('item k', item[k].message)
              return ErrorMapper({ item: item[k] });
            });
          }

          return ErrorMapper({ item });
        })}
      </div>
    );
  } catch (ex) {
    console.log("ex", ex);
    return "Error occured!";
  }
};

const ErrorMapper = ({
  item,
}: {
  item: {
    message: string;
  };
}) => {
  return <p>{item.message}</p>;
};

export const safeStringify = (obj: any, indent: number = 2): string => {
  const seen = new WeakSet();

  return JSON.stringify(
    obj,
    (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return ""; //'[Circular Reference]';
        }
        seen.add(value);
      }
      return value;
    },
    indent
  );
};
